import { RouteType } from "../config";
import BuildIcon from "@material-ui/icons/Build";
import ProgramaManutencaoPage from "../../pages/ProgramaManutencao/ProgramaManutencaoPage";
import DashboardPageLayout from "../../components/layout/DashboardPageLayout";
import HomePage from "../../pages/home/HomePage";
import MovimentacaoEmManutencaoPage from "../../pages/ProgramaManutencao/MovimentacaoEmManutencaoPage";

const grupoProgramaManutencao: RouteType = {
  path: "/programaManutencao",
  element: <DashboardPageLayout />,
  state: "PROGRAMA_MANUTENCAO",
  show: true,
  verificarPermissao: (usuario) => {
    return usuario?.perfil.podeAcessarPlanoManutencao ?? false;
  },
  sidebarProps: {
    displayText: "Programa de Manutenção",
    icon: <BuildIcon />,
  },

  child: [
    {
      index: true,
      element: <HomePage />,
      state: "configuracao.index",
      show: true,
    },
    {
      path: "/programaManutencao/solicitacoes",
      element: <ProgramaManutencaoPage />,
      state: "programaManutencao.solicitacao",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarPlanoManutencao ?? false;
      },
      sidebarProps: {
        displayText: "Solicitações de Manutenção",
      },
    },

    {
      path: "/programaManutencao/movimentacoes",
      element: <MovimentacaoEmManutencaoPage />,
      state: "programaManutencao.movimentacao",
      show: true,
      verificarPermissao: (usuario) => {
        return usuario?.perfil.podeAcessarPlanoManutencao ?? false;
      },
      sidebarProps: {
        displayText: "Movimentações de Manutenção",
      },
    },
  ],
};

export default grupoProgramaManutencao;
